import { createFileRoute } from "@tanstack/react-router";
import { PolicyPage, policyHead } from "../pages/PolicyPage";

export const Route = createFileRoute("/contact-us")({
  head: () => policyHead("contact"),
  component: () => <PolicyPage page="contact" />
});
